module.exports = __webpack_public_path__ + "static/media/scottish_widows_tablet.72da1ef7.png";